<template>
  <MenuItem v-slot="{ active }">
    <a
      href="#"
      @click.prevent="handleClick"
      :class="[
        active ? activeClasses : defaultClasses,
        'block px-4 py-2 text-sm',
      ]"
    >
      {{ label }}
    </a>
  </MenuItem>
</template>

<script setup>
import { MenuItem } from "@headlessui/vue"
import { computed } from "vue"

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "neutral",
  },
  onClick: {
    type: Function,
    default: null,
  },
})

const colorMap = {
  red: {
    default: "text-red-600 dark:text-red-400",
    active: "text-red-100 bg-red-600",
  },
  neutral: {
    default: "text-neutral-content",
    active: "bg-base-200 dark:bg-neutral text-neutral-content",
  },
}

const getColorClasses = color => colorMap[color] || colorMap.neutral //default to neutral

const classes = getColorClasses(props.color)
const defaultClasses = computed(() => classes.default)
const activeClasses = computed(() => classes.active)

const handleClick = () => {
  if (props.onClick) {
    props.onClick()
  }
}
</script>
